import RWD002 from "../class/rwd002";
import customDrawerNav from "./drawerNav";
import customFormConfirm from "./formConfirm";
import customSubNav from "./subNav";
import LazyDisp from "../class/lazydisp";
import $ from 'jquery';

const [d] = [document];

export default class CUSTOMIZE extends RWD002 {

  constructor(opt) {
    opt = Object.assign({
      // fixNavを指定すると、スクロール時に固定するクラスを付与する
      // fixNav : '[data-role="fixNav"]',
      // Keep first paint visible for Lighthouse/mobile by disabling full-page fade-in.
      loading: false,
    },opt);

    // 上位クラスのコンストラクタ呼び出し
    super(opt);

    // カスタム用drawerNavのインスタンス化
    this.drawerNav = new customDrawerNav(this.opt.drawerNav);

    // カスタム用サブナビ登録クラスのインスタンス化
    this.Subnav = new customSubNav(this.opt);

    // コメントフォーム用確認画面モーダルのインスタンス化
    this.formConfirm = new customFormConfirm(this.opt.formConfirm);

    this.customInit();
  }

  customInit() {

    // イベント一覧
    d.addEventListener('rwd002.beforeInit', () => false );
    d.addEventListener('rwd002.beforeDomready', () => false );
    d.addEventListener('rwd002.beforeWindowload', () => false );
    d.addEventListener('rwd002.zip2addr', () => false );
    d.addEventListener('drawerNav.beforeInit', () => false );
    d.addEventListener('collapseNav.beforeInit', () => false );
    d.addEventListener('Scroll.beforeInit', () => false );
    d.addEventListener('Scroll.scrollUp', () => false );
    d.addEventListener('Scroll.scrollDown', () => false );
    d.addEventListener('Lazydisp.beforeInit', () => false );

    // テンプレートインスタンスのプロミス
    this.promises.init.then( () => false );
    this.promises.domReady.then( () => false );
    this.promises.windowLoad.then( () => false );

    // テンプレートインスタンスの全非同期メソッドの完了時に実行
    this.promiseAll().then( () => false );

    // サブナビ登録サンプル
    d.addEventListener('rwd002.beforeDomready', () => {
      this.customSubnav();
    });

    $(() => {
      // htmlデータ読み込み
      $('[data-load-html]').loadHtml();

      // カレントメニュー
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});

      Promise.all([window.load['loadHtml']]).then(() => this.hashscroll());
      Promise.all([window.load['loadHtml']]).then(() => new LazyDisp('[data-lazydisp]'));

      const $megaMenuItems = $('.rwd002-gnav-item').filter(function() {
    return $(this).find('.rwd002-subnav').length > 0;
  });

  const $allbox = $('#allbox');

  // 2. ホバーイベントの設定
  $megaMenuItems.on({
    'mouseenter': () => {
      $allbox.addClass('is-dark');
    },
    'mouseleave': () => {
      $allbox.removeClass('is-dark');
    }
  });
    });
  }

  // サブメニュー追加サンプル(beforeDomreadyに登録して使用)
  customSubnav () {
    /**
     * サブナビ追加メソッド(グローバルナビとフッター)
     * ヘッダー・フッター内の[data-key]属性値をもつ要素すべてに対して、サブナビを追加する
     * 第一引数にセレクタを指定(rwd002.opt.gnav / rwd002.opt.fnav )
     * 第一引数にコンテンツ番号を指定(li[data-key])
     * アイテムの出力HTMLは"subnavItemTemplate"によって出力される
     * 第二引数の個別アイテムにHTMLを指定すると、デフォルトのHTMLを上書きする
     * 親要素liに[data-collapse="true"]を指定すると、サブナビを開閉するボタンを追加する
     */

    const originalTemplate = this.Subnav.outerTemplate;
  
    this.Subnav.outerTemplate = (html) => {
      return `
        <div class="rwd002-subnav is-custom collapse">
          <div class="rwd002-subnav__inner">
            <p class="rwd002-subnav__title pc">ウェブサポとは</p>
            <ul class="rwd002-subnav__list">${html}</ul>

            <div class="rwd002-subnav__banner-wrap pc">
              <a href="https://secure.websapo.jp/registration/" class="rwd002-subnav__banner-link" target="_blank" rel="noopener noreferrer">
                <p class="rwd002-subnav__banner-lead">
                  約3分で<br>
                  30日間お試しアカウントを<br>
                  発行できます
                </p>
                <p class="rwd002-subnav__banner-accent">
                  今すぐ30日間無料おためし
                </p>
              </a>
            </div>
          </div>
        </div>
      `;
    };

    // header gnav用サブナビ追加
    this.Subnav.add(this.opt.gnav, 'content2', [
      // 標準出力
      // { label: '特徴・強み', href: '#'},
      // { label: '多彩な機能', href: '#'},
      // { label: '豊富なデザインテンプレート', href: '#'},
      // { label: 'あんしんの理由', href: '#'},

      // カスタマイズHTMLも追加可能
      { html: `
        <li class="${this.Subnav.opt.subnavClass}-item">
          <a href="/service/" class="${this.Subnav.opt.subnavClass}-item__link">
            <span>特徴・強み</span>
            <svg class="icon icon_arrow pc">
              <use href="/assets/svg/sprite.symbol.svg#icon_arrow"></use>
            </svg>
          </a>
        </li>
        <li class="${this.Subnav.opt.subnavClass}-item">
          <a href="/service/?mode=detail&article=13" class="${this.Subnav.opt.subnavClass}-item__link">
            <span>多彩な機能</span>
            <svg class="icon icon_arrow pc">
              <use href="/assets/svg/sprite.symbol.svg#icon_arrow"></use>
            </svg>
          </a>
        </li>
        <li class="${this.Subnav.opt.subnavClass}-item">
          <a href="/service/?mode=detail&article=31" class="${this.Subnav.opt.subnavClass}-item__link">
            <span>豊富なデザインテンプレート</span>
            <svg class="icon icon_arrow pc">
              <use href="/assets/svg/sprite.symbol.svg#icon_arrow"></use>
            </svg>
          </a>
        </li>
        <li class="${this.Subnav.opt.subnavClass}-item">
          <a href="/service/?mode=detail&article=21" class="${this.Subnav.opt.subnavClass}-item__link">
            <span>あんしんの理由</span>
            <svg class="icon icon_arrow pc">
              <use href="/assets/svg/sprite.symbol.svg#icon_arrow"></use>
            </svg>
          </a>
        </li>
        `
      },
    ]);

    // footer nav用サブナビ追加
    this.Subnav.add(this.opt.fnav, 'content2', [
      { label: 'ウェブサポの特徴・強み', href: '/service/'},
      { label: '多彩な機能', href: '/service/?mode=detail&article=13'},
      { label: '豊富なデザインテンプレート', href: '/service/?mode=detail&article=31'},
      { label: 'あんしんの理由', href: '/service/?mode=detail&article=21'},
      { label: 'ご利用規約', href: '/service/?mode=detail&article=33'},
    ]);
    this.Subnav.add(this.opt.fnav, 'content6', [
      { label: 'お知らせ', href: '/information/?mode=list&cat=3'},
      { label: 'メンテナンス情報', href: '/information/?mode=list&cat=2'},
      { label: '記事作成講座', href: '/information/?mode=list&cat=8'},
      { label: 'ご報告', href: '/information/?mode=list&cat=4'},
      { label: '更新情報', href: '/information/?mode=list&cat=6'},
      { label: '3分でわかる操作説明', href: '/information/?mode=list&cat=9'},
    ]);
  }

  loading() {
    d.documentElement.classList.add( this.opt.loadingClass );
    d.documentElement.classList.add( 'is-pageload-available' );
    d.addEventListener('DOMContentLoaded', () => {
      d.documentElement.classList.remove( this.opt.loadingClass );
      d.documentElement.style.opacity = '';
    });
  }
}

window.WebFontConfig = {
  google: {
    // families: ['Mulish:600', 'Jost:500,600', 'Roboto:400,500,700', 'Montserrat:600', 'Noto+Sans+JP:600&subset=japanese']
    families: ['Roboto:900', 'Montserrat:400,500,600,700', 'Noto+Sans+JP:400,500,600,700&subset=japanese']
  },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();